const usersInit = {
  email: "",
  role: -1,
  userId: "",
  name: "",
  lastName: "",
  birthDate: "",
  gender: "",
  educationLevel: -1,
  phoneNumber: "",
  photoUrl: "",
};

const users = {
  email: "",
  role: "",
  userId: "",
  name: "",
  lastName: "",
  birthDate: "",
  gender: "",
  educationLevel: "",
  phoneNumber: "",
  photoUrl: "",
};

const setUsersInitState = () => {
  return usersInit;
};

const usersParserFromServer = (objectResponse) => {
  let out = users;
  out.email = objectResponse.email;
  out.role = objectResponse.role;
  out.userId = objectResponse.userId;
  out.name = objectResponse.name;
  out.lastName = objectResponse.lastName;
  out.birthDate = formatDate(objectResponse.birthDate);
  out.gender = objectResponse.gender;
  out.educationLevel = objectResponse.educationLevel;
  out.phoneNumber = objectResponse.phoneNumber;
  out.photoUrl = objectResponse.photoUrl;
  out.webSite = objectResponse.webSite;
  out.additionalRoles = objectResponse.additionalRoles;
  return out;
};

const formatDate = (date) => {
  if (date.day !== undefined) {
    let day = date.day.toString().length === 1 ? "0" + date.day : date.day;
    let month =
      date.month.toString().length === 1 ? "0" + date.month : date.month;
    let year = date.year;
    return `${day}/${month}/${year}`;
  }
  return "";
};

export { usersParserFromServer, setUsersInitState };
